export default __webpack_public_path__ + "static/media/logo-12.0650eac6.png";